import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => createStyles({
  headline: {
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(26),
    },
  },
  checkIcon: {
    color: theme.palette.success.main,
    position: 'absolute',
    width: '1.76rem',
    height: '1.76rem',
    top: '2px',
    left: 0,
  },
  heroImageColumn: {
    alignSelf: 'stretch',
  },
  heroImageContainer: {
    position: 'relative',
    width: '100%',
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      height: '35.5rem',
    },
  },
  heroImage: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '35.5rem',
    [theme.breakpoints.down('sm')]: {
      left: '50%',
      marginLeft: theme.spacing(-35),
    },
    [theme.breakpoints.up('md')]: {
      top: 0,
      left: theme.spacing(-17),
      height: '53.5rem',
    },
    [theme.breakpoints.up('lg')]: {
      height: '61.6rem',
      left: theme.spacing(-19),
    },
  },
  logoImage: {
    height: '1.5rem',
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      height: '3.2rem',
      marginTop: theme.spacing(5),
      marginRight: theme.spacing(4),
    },
  },
}))
